const DEFAULT_COLLECTION_ORDERS = {
  Dog: [
    'Dog/Fencing',
    'Dog/Training',
    'Dog/Harnesses & Leashes',
    'Dog/Fountains & Feeders',
    'Dog/Doors',
    'Dog/Toys',
    'Dog/Travel',
    'Dog/Mobility',
    'Dog/Life Stages',
    'Dog/Parts & Accessories',
  ],
  'Dog/Fencing': [
    'Dog/Fencing/Wireless Pet Fences',
    'Dog/Fencing/In-Ground Pet Fences',
    'Dog/Fencing/GPS Pet Fences',
    'Dog/Fencing/Collars, Batteries & Accessories',
  ],
  'Dog/Training': [
    'Dog/Training/Bark Control',
    'Dog/Training/Training Collars',
    'Dog/Training/Obedience Training Tools',
    'Dog/Training/Pet Proofing & Deterrents',
    'Dog/Training/No-Pull Training',
    'Dog/Training/House Training',
    'Dog/Training/Collars, Batteries & Accessories',
  ],
  'Dog/Harnesses & Leashes': [
    'Dog/Harnesses & Leashes/Harnesses',
    'Dog/Harnesses & Leashes/Collars',
    'Dog/Harnesses & Leashes/Leashes',
  ],
  'Dog/Fountains & Feeders': [
    'Dog/Fountains & Feeders/Fountains',
    'Dog/Fountains & Feeders/Feeders',
    'Dog/Fountains & Feeders/Filters & Accessories',
  ],
  'Dog/Doors': [
    'Dog/Doors/Door & Wall-Entry',
    'Dog/Doors/Sliding Glass Doors',
    'Dog/Doors/Flaps & Accessories',
  ],
  'Dog/Toys': [
    'Dog/Toys/Automated Toys',
    'Dog/Toys/Treat Dispensing Toys',
    'Dog/Toys/Treat Ring Chew Toys',
    'Dog/Toys/Treat Ring Refills',
  ],
  'Dog/Travel': [
    'Dog/Travel/Carriers',
    'Dog/Travel/Car Seats & Covers',
    'Dog/Travel/Car Ramps & Steps',
    'Dog/Travel/Car Accessories',
  ],
  'Dog/Mobility': ['Dog/Mobility/Steps & Ramps', 'Dog/Mobility/Lifting Aids'],
  'Dog/Life Stages': [
    'Dog/Life Stages/New Puppy Shop',
    'Dog/Life Stages/Senior Dog Essentials',
  ],
  'Dog/Parts & Accessories': [],
  Cat: [
    'Cat/Litter Boxes & Litter',
    'Cat/Doors',
    'Cat/Fountains & Feeders',
    'Cat/Toys',
    'Cat/Barriers',
    'Cat/Travel',
    'Cat/Life Stages',
    'Cat/Parts & Accessories',
  ],

  'Cat/Litter Boxes & Litter': [
    'Cat/Litter Boxes & Litter/Litter Boxes',
    'Cat/Litter Boxes & Litter/Litter',
    'Cat/Litter Boxes & Litter/Litter Trays',
    'Cat/Litter Boxes & Litter/Hoods & Accessories',
  ],
  'Cat/Doors': [
    'Cat/Doors/Exterior Doors',
    'Cat/Doors/Interior Doors',
    'Cat/Doors/Microchip Doors',
    'Cat/Doors/Sliding Glass Doors',
    'Cat/Doors/Flaps & Accessories',
  ],
  'Cat/Fountains & Feeders': [
    'Cat/Fountains & Feeders/Fountains',
    'Cat/Fountains & Feeders/Feeders',
    'Cat/Fountains & Feeders/Filters & Accessories',
  ],
  'Cat/Toys': ['Cat/Toys/Automated Toys', 'Cat/Toys/Treat Dispensing Toys'],
  'Cat/Barriers': [
    'Cat/Barriers/Pet Proofing & Deterrents',
    'Cat/Barriers/Cat Fencing',
    'Cat/Barriers/Batteries & Accessories',
  ],
  'Cat/Travel': [
    'Cat/Travel/Cat Harnesses',
    'Cat/Travel/Carriers',
    'Cat/Travel/Car Seats & Covers',
  ],
  'Cat/Life Stages': [
    'Cat/Life Stages/New Kitten Shop',
    'Cat/Life Stages/Senior Cat Essentials',
  ],
  'Cat/Parts & Accessories': [],
  'All Products': [
    'All Products/Litter Boxes & Litter',
    'All Products/Fencing',
    'All Products/Training',
    'All Products/Harnesses & Leashes',
    'All Products/Doors',
    'All Products/Fountains & Feeders',
    'All Products/Toys',
    'All Products/Travel',
    'All Products/Mobility',
    'All Products/Parts & Accessories',
  ],
};

const menuCollectionSorter = (title, collection) => {
  if (!collection?.childCollections) {
    return collection;
  }

  let childCollections = collection?.childCollections.sort((a, b) => {
    const sortOrder = DEFAULT_COLLECTION_ORDERS[title];

    const aIndex = sortOrder?.indexOf(a.store.title);
    const bIndex = sortOrder?.indexOf(b.store.title);

    if (!sortOrder || aIndex === undefined) {
      return 1;
    }

    return aIndex - bIndex;
  });

  childCollections = [
    ...childCollections.filter(c =>
      DEFAULT_COLLECTION_ORDERS[title]?.includes(c.store.title)
    ),
    ...childCollections.filter(
      c => !DEFAULT_COLLECTION_ORDERS[title]?.includes(c.store.title)
    ),
  ];

  // ! collection?.collection?.navChildCollectionsOrder is from top level like `Dog` and is an exception from normal
  if (
    collection.navChildCollectionsOrder?.length > 0 ||
    collection?.parentCollection?.navChildCollectionsOrder?.length > 0 ||
    collection?.collection?.navChildCollectionsOrder?.length > 0
  ) {
    const newOrderCollections =
      collection?.navChildCollectionsOrder ||
      collection?.parentCollection?.navChildCollectionsOrder ||
      collection?.collection?.navChildCollectionsOrder;

    childCollections = childCollections.sort((a, b) => {
      const aIndex = newOrderCollections.findIndex(
        co => co.store?.title === a.store?.title
      );
      const bIndex = newOrderCollections.findIndex(
        co => co.store?.title === b.store?.title
      );

      if (!newOrderCollections || aIndex === undefined) {
        return 1;
      }
      return aIndex - bIndex;
    });

    childCollections = [
      ...childCollections.filter(c =>
        newOrderCollections.some(co => co.store?.title === c.store?.title)
      ),
      ...childCollections.filter(
        c => !newOrderCollections.some(co => co.store?.title === c.store?.title)
      ),
    ];
  }

  return {
    ...collection,
    childCollections,
  };
};

export default menuCollectionSorter;
